module.exports = __webpack_public_path__ + "assets/img/39cc30c81378956ec25d617b0da9e279.png";